if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.scrollHandler);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);

      // Desktop: the product info counts as out of view only once it has scrolled under the sticky
      // header. The header's height changes as the menu hides/shows on scroll, so it's re-measured
      // on every (rAF-throttled) scroll rather than baked into an IntersectionObserver rootMargin.
      if (this.productInfo) {
        this.scrollHandler = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.updateDesktopVisibility();
          });
        };
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        window.addEventListener('resize', this.scrollHandler);
        this.updateDesktopVisibility();
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    updateDesktopVisibility() {
      if (!theme.mediaMatches.md) return;
      const infoRect = this.productInfo.getBoundingClientRect();
      const headerBottom = StickyAtcPanel.getStickyHeaderBottom();
      this.classList.toggle('sticky-atc-panel--out', infoRect.bottom > headerBottom && infoRect.top < window.innerHeight);
    }

    /**
     * Returns the viewport position of the bottom edge of the sticky header (0 if it isn't sticky)
     * @returns {number}
     */
    static getStickyHeaderBottom() {
      // Measure the inner .header: when the menu hides on scroll the section keeps its height via
      // margin-bottom, but the visible header shrinks
      const header = document.querySelector('.cc-header--sticky .header') || document.querySelector('.cc-header--sticky');
      if (!header) return 0;
      return Math.max(0, header.getBoundingClientRect().bottom);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
